import { defineStore } from "pinia";

const useHomeStore = defineStore('home', {
  state: () => ({
    showLogin: false, //是否显示登录弹窗
    showRegister: false,
    showForget: false,
  }),
  getters: {},
  actions: {
    changeLogin() {
      this.showLogin = !this.showLogin;
    },
    changeReg() {
      this.showRegister = !this.showRegister;
    },
    changeForget() {
      this.showForget = !this.showForget;
    }
  }
});

export default useHomeStore